import { useEffect } from "react";

import { Button, Card, Flex, Form, Input, Skeleton } from "antd";

import DragHandle from "@/components/ui/DragHandle";

import CloseIcon from "@/icons/CloseIcon";
import EditIcon from "@/icons/EditIcon";

import FieldsList from "./FieldsList";
import FieldsTable from "./FieldsTable";

const GroupCard = ({
  templateFieldIds = [],
  group,
  index,
  onSave,
  onRemove,
  toggleEdit,
  SortableGroupContext,
  isDeleted,
  isStatic = false,
  pending = false,
  isAnyGroupEditing = false,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      title: group.name,
      fields: group.fields || [],
    });
  }, [group, form]);

  return (
    <Card
      size="small"
      title={
        !group.isEditing ? (
          <Flex align="center" gap={8}>
            {!isDeleted && !isStatic && (
              <DragHandle context={SortableGroupContext} />
            )}
            {group.name || `Группа полей ${index + 1}`}
          </Flex>
        ) : null
      }
      extra={
        !isDeleted && !isStatic && !isAnyGroupEditing ? (
          <Flex gap={4}>
            {!group.isEditing && (
              <Button
                type="text"
                icon={<EditIcon />}
                onClick={() => toggleEdit(group.id, true)}
              />
            )}
            <Button
              type="text"
              danger
              icon={<CloseIcon />}
              onClick={() => onRemove(group)}
            />
          </Flex>
        ) : null
      }
      style={{ boxShadow: "none" }}
    >
      <Skeleton active loading={pending}>
        <Form
          form={form}
          initialValues={{
            name: group.name,
            fields: group.fields || [],
          }}
          layout="vertical"
        >
          {!isDeleted && !isStatic && group.isEditing && (
            <Form.Item
              name="name"
              label="Название группы"
              rules={[{ required: true, message: "Введите название группы" }]}
            >
              <Input />
            </Form.Item>
          )}

          {!isDeleted && !isStatic && group.isEditing ? (
            <FieldsList
              templateFieldIds={templateFieldIds}
              groupName="fields"
              isEditing={group.isEditing}
            />
          ) : (
            <FieldsTable fields={group.fields} />
          )}

          {!isDeleted && !isStatic && group.isEditing && (
            <Flex justify="end" align="center" gap={8}>
              <Button
                onClick={() => {
                  if (group.isNew) {
                    onRemove(group);
                  } else {
                    form.resetFields();
                    toggleEdit(group.id, false);
                  }
                }}
              >
                Отмена
              </Button>

              <Button
                type="primary"
                loading={pending}
                onClick={async () => {
                  try {
                    const values = await form.validateFields();

                    await onSave(group, values);
                  } catch (e) {
                    console.log(e);
                  }
                }}
              >
                Сохранить
              </Button>
            </Flex>
          )}
        </Form>
      </Skeleton>
    </Card>
  );
};

export default GroupCard;
